import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { stringifyIfPresent } from 'src/lib/common';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation HubspotTrackEvent($eventName: HubspotEventsEnum!, $attributes: JSON) {
    hubspotTrackEvent(eventName: $eventName, attributes: $attributes) {
      id
    }
  }
`;

export function trackHubspotEvent(eventName: string, attributes: object) {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: {
      eventName,
      attributes: stringifyIfPresent(attributes),
    },
  }).then(({ data }) => getSingleProp(data));
}
